<div class="brand-chip"
    [class.disabled]="disabled"
    [class.expanded]="isExpanded"
    (click)="toggleExpanded()">
    <div class="logo-wrapper">
        <img class="brand-logo" [src]="icon" (error)="onIconError($event)"/>
        <span class="color-dot" *ngIf="!disabled && displayBrandColor" [style.background-color]="color"></span>
    </div>
    <div class="brand-wrapper">
        <span class="brand-name">{{ label }}</span>
        <span class="remove-btn" *ngIf="!disabled && displayRemoveButton" (click)="onBrandRemove($event)">
            <app-remove-icon></app-remove-icon>
        </span>
    </div>
</div>
<ng-content *ngIf="!disabled && _brandsOptions?.length">
    <app-select-menu
        [items]="_brandsOptions"
        [selectMode]="SelectMode.ATTACHED_SINGLE"
        [hideSelected]="true"
        [control]="control"
        [dropDownPosition]="'bottom'"
        [searchable]="_brandsOptions.length > 6"
        [openPanel]="isPanelOpen"
        (onApply)="onBrandChanged($event)">
    </app-select-menu>
</ng-content>
